<template>
  <div ref="levelwidth"
       class="house">
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作桌面</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动列表</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="downloadClient" v-if="0" :style="{backgroundColor:isCustom ? customColor: isSimple ? '#FD9112' : '#185ED3' }" :class=" isSimple ? 'simplerefresh' : 'refresh'">
        <img style="margin-right:6px;" src="@/assets/house/client.png" alt="">
        <p>客户端下载</p>
      </div>
    </div>

    <!-- 正文部分 -->
    <div class="housemain">
      <div style="width:100%;height:500px;position: relative;">
        <div style="float:left;">
          <div class="number">
            <div class="header">
              <h4>Hi,<span>{{creatName}}</span></h4>
              <div v-if="false"
                   :class="isSimple ? 'simplechange' : 'change'">
                <img width="15px"
                     height="15px"
                     style="margin-left:23px;margin-right:7px;"
                     src="@/assets/house/change.png"
                     alt="">
                <p>切换桌面</p>
              </div>
            </div>
            <div class="main" v-if="numberFlag">
              <!-- <div class="mainpic" style="background:url('@/assets/house/pic1.png')">
                <p>图片数</p>
                <div style="display:flex;">
                  <p><vns :start="0" :end="20" :times="26" :speed="50"></vns></p>
                  <p>{{e.numre}}</p>
                </div>
              </div> -->
              <div v-for="(e,i) in numberList"
                   :key="i"
                   class="mainpic"
                   :style="{background:'url(' + e.src +')',backgroundSize:'100% 100%'}">
                <p>{{e.text}}</p>
                <div style="display:flex;">
                  <p>
                    <vns :start="0"
                         :end="e.num"
                         :times="26"
                         :speed="50"></vns>
                  </p>
                  <p>{{e.numre}}</p>
                </div>
              </div>
            </div>
            <div class="main" v-else>
              <!-- <div class="mainpic" style="background:url('@/assets/house/pic1.png')">
                <p>图片数</p>
                <div style="display:flex;">
                  <p><vns :start="0" :end="20" :times="26" :speed="50"></vns></p>
                  <p>{{e.numre}}</p>
                </div>
              </div> -->
              <div v-for="(e,i) in numberList"
                   :key="i"
                   class="mainpic"
                   :style="{background:'url(' + e.src +')',backgroundSize:'100% 100%'}">
                <p>{{e.text}}</p>
                <div style="display:flex;">
                  <p>
                    <vns :start="0"
                         :end="e.num"
                         :times="26"
                         :speed="50"></vns>
                  </p>
                  <p>{{e.numre}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="disflex">
            <div class="nav">

              <div class="header">
                <h4>快速导航</h4>
                <!-- <p>更多>></p> -->
              </div>

              <div class="main">
                <div @click="navClick(i)"
                     v-for="(e,i) in navList"
                     :key="i"
                     class="mainpic">
                  <img height="80px"
                       width="80px"
                       :src="e.src"
                       alt="">
                  <p>{{e.text}}</p>
                </div>
              </div>
            </div>
            <div v-if="0" class="catalog"
                 >
                 <!-- v-if="powersObj.openLocalDisk && contributorData.nasInfo"> -->

              <div class="header">
                <h4>专用共享目录</h4>
                <!-- <p>更多>></p> -->
              </div>

              <div class="main">

                <p>地址：<span>{{catalog.path}}</span></p>
                <p>账号：<span>{{catalog.account}}</span></p>
                <div class="psw"><span style=" font-size: 14px;color: #333333;font-weight: bold;font-family:Microsoft YaHei;">密码：</span><span>{{ seepswFlag ? catalog.password : catalog.hidpsw}}</span>
                  <div @click="seePsw"
                       :class="!seepswFlag?'seepsw':'hidpsw'"></div>
                </div>
                <div class="copy"
                     v-clipboard:copy="catalogCopy"
                     v-clipboard:success="onCopy"
                     v-clipboard:error="onError">复制</div>
              </div>
            </div>

            <div v-if="0" class="catalog notcatalog"
                 >
                 <!-- v-if="!powersObj.openLocalDisk || !contributorData.nasInfo"> -->

              <div class="header">
                <h4>专用共享目录</h4>
                <!-- <p>更多>></p> -->
              </div>

              <div class="main">
                <img src="@/assets/house/warehousing.png"
                     alt="">
                <p style="margin-left:5px;margin-bottom:0px;">系统未开启共享盘功能或您没有此权限，请联系管理员开通。</p>
                <!-- <p>地址：<span>{{catalog.path}}</span></p>
                <p>账号：<span>{{catalog.account}}</span></p>
                <div class="psw"><span style=" font-size: 14px;color: #333333;font-weight: bold;font-family:Microsoft YaHei;">密码：</span><span>{{ seepswFlag ? catalog.password : catalog.hidpsw}}</span>
                  <div @click="seePsw" :class="!seepswFlag?'seepsw':'hidpsw'"></div>
                </div>
                <div class="copy" v-clipboard:copy="catalogCopy" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="headers">
            <p @click="picMore" :class="isSimple ? 'simple' : ''">更多>></p>
        </div> -->
        <div class="picneeds">
          <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="图片邀约" v-if='0' name="first">
    
              <!-- :row-style="{height:51 + 'px'}" -->
              <div class="main">
              <div class="pictable">
              <el-table :data="contributorData.pictureNeeds"
                          :row-style="{height:51 + 'px'}"
                          style="width:100%;"
                          @row-click="rowClick">
              <el-table-column prop="createAtMY"
                                  label="日期"
                                  :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="userName"
                                  label="姓名"
                                  :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="title"
                                  :show-overflow-tooltip="true"
                                  :width="displayResolution < 1600?'80':'300'"
                                  label="需求标题">
                  </el-table-column>
                </el-table>
              </div>
            </div>
      </el-tab-pane>
      <el-tab-pane label="热点资源" name="second" v-if="hotspot">
            <div class="main">
              <div class="pictables">
              <el-table :data="data"
                          :row-style="{height:51 + 'px'}"
                          style="width:100%;"
                          @row-click="rowClick">
              <el-table-column prop="createTimeat"
                                  label="日期"
              :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="resourceCreateUserName"
                                  label="上传者"
                                  :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="desc"
                                  :show-overflow-tooltip="true"
                                  :width="displayResolution < 1600?'80':'300'"
                                  label="图片说明">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            
      </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div style="display: flex;flex-wrap: nowrap;">
        <div style="width:48%;position: relative;display: flex;flex-wrap: nowrap;">
          <div class="uploads">

              <div class="header">
                <h4>最近上传</h4>
                <p @click="uploadMore" :class="isSimple ? 'simple' : ''">更多>></p>
              </div>

              <div v-loading="uploadsLoading"
                  :style="{gridTemplateColumns:uploadsList.length < 5 ? 'repeat(auto-fit, 300px)' : 'repeat(auto-fit, minmax(250px, 1fr))'}"
                  class="main">
                <div class="uploadspic"
                    v-for="(e,i) in uploadsList"
                    :key="i">
                  <div style="width: 100%;min-height: 200px;overflow: hidden;">
                    <div @click="intoPicList(e.id)"
                        class="pic"
                        :style="{backgroundImage:'url('+ e.src +')'}">
                      <div class="sheets">
                        <img src="@/assets/piclist/pic.png" alt="">
                        {{e.pictureCount}}
                        <img src="@/assets/piclist/video.png" alt="">
                        {{e.videoCount}}
                      </div>
                    </div>
                  </div>
                  <el-tooltip class="item" effect="dark" :content="e.name" placement="top">
                    <p v-if="e.name.length > 13">{{e.name.substring(0,13) + '…'}}</p>
                  </el-tooltip>
                  <p v-if="e.name.length <= 13">{{e.name}}</p>
                  <div class="disflex">
                    <p>{{e.mycreateAt}}</p>
                  </div>
                </div>

                <!-- <template v-if="uploadsList.length%row > 0">
                  <div class="list"
                      :style="{width:widthWithUP}"
                      v-for="(item,index) in (row-(uploadsList.length)%row)"
                      :key="'list'+index"></div>
                </template> -->

                <template v-if="uploadsList.length === 0">
                  <div class="nopic">
                    <img src="@/assets/piclist/nonr.png"
                        alt="">
                  </div>
                </template>

              </div>

          </div>
          <!-- <div class="chart-container">
            <div class="title"> 达标量</div>
          </div> -->




          
        </div>
        <div class="static" >
          <div style="height: 80px;position: relative;z-index:100">
            <div  style="display: flex;justify-content: space-between;align-items: center;">
              <h4 style="margin-bottom: 10px;">{{ chartType }}达标量</h4>
              <p @click="dataSortMore()" style="font-size: 12px; color: #333333;cursor: pointer;"  :class="isSimple ? 'simple' : ''">更多>></p>
            </div>
            
            <div style="display: flex; justify-content: space-between;gap: 20px;">
              <el-radio-group v-model="chartType" @input="paramsChange">
                <el-radio-button label="月度"></el-radio-button>
                <el-radio-button label="年度"></el-radio-button>
              </el-radio-group>
              <el-date-picker
              v-if="chartType=='月度'"
              @change="paramsChange"
                v-model="selectMonth"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
              <el-date-picker
              v-if="chartType=='年度'"
                v-model="selectYear"
              @change="paramsChange"

                type="year"
                format="yyyy"
                value-format="yyyy"
                placeholder="选择年">
              </el-date-picker>
            </div>
          </div>
          <div class="echart" id="mychart1" style="height: calc(100% - 80px);min-height: 800px;background-color: #fff;"  :style="myChartStyle"></div>

        
        </div>
      </div>






    </div>

    <el-dialog :visible.sync="dialogVisible"
               width="40%"
               :before-close="handleClose">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div v-if="activeName=='first'">图片邀约详情</div>
        <div v-if="activeName=='second'">热点资源详情</div>
      </div>
      <div>
        <div style="text-align:center;font-size:15px;font-weight:600;margin-bottom:15px;">{{this.picMsg.title}}</div>
        <div style="display:flex;justify-content: space-around;">
          <div>上传人：{{this.picMsg.userName}}</div>
          <div>创建时间：{{this.picMsg.createAtMY}}</div>
        </div>
        <div style="width:80%;text-align:center;font-size:15px;font-weight:600;margin:25px auto;border-top:1px solid #cccccc;"></div>
        <div style="width:75%;margin:10px auto;" v-if="activeName=='first'">
          <div v-html="this.picMsg.content"
               style="height:420px;overflow-y: auto;box-sizing: border-box;padding:20px;box"></div>
        </div>
        <div v-if="activeName=='second'" class="secondimg">
           <img width="460px" :src="picPrefix + this.picMsg.picThumbW1080" alt="">
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import vns from 'vue-number-scroll'
import * as echarts from "echarts";
import { powersObj, allowLib } from "@/constants/powers";
import { picPrefix } from "@/constants/piccommon";
import { mapGetters } from "vuex";
import { getUser } from "@/api/user";
import { desktopEditor } from "@/api/userCenter";
import { getPictureNeed } from "@/api/pictureNeed";
import { getDesktopVersion } from "@/api/open";
import { searchAtlas,searchPicture,advSearchPicture } from '@/api/search'
import { generateIndexPic } from "@/api/atlas";
import { getDate, formatConversion } from "@/plugins/getdate";
import { getDepartmentCountListApi } from "@/api/department";


export default {
  components: {
    'vns': vns
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      departmentList:[],
      pieData: [
        {
          id: 1,
          value: [],
          name: "图片"
        },
        {
          id:2,
          value: [],
          name: "视频"
        }
      ],
      pieName: [],
      myChart: {},
      myChartStyle:{ float: "left", width: "100%"  },
      chartType: '月度',
      selectMonth: '',
      selectYear:'',
    activeName: 'second',
      //用户姓名
      creatName: '',
      //权限
      powersObj,
      allowLib,
      //图集间距
      atlasMargin: '',
      picPrefix,
      picMsg: {},
      dialogVisible: false,
      contributorData: {},
      isAside: this.bus.val,
      uploadsList: [],
      uploadsLoading: false,
      //图集分辨率
      widthWithUP: '',
      row: 5,
      displayResolution: '',
      hotspot:false,
      //专用共享目录
      catalog: {
      },
      data:[],
      catalogCopy: '',
      seepswFlag: false,  //是否隐藏密码
      numberFlag:false,
      numberList: [
        {
          src: require('@/assets/house/house1.png'),
          // num:this.contributorData.pictureDataCount.shareCount,
          text: '资源集数'
        },
        {
          src: require('@/assets/house/house2.png'),
          // num:this.contributorData.createPictureCount,
          text: '图片数'
        },
        {
          src: require('@/assets/house/house3.png'),
          // num:this.contributorData.createPictureCount,
          text: '视频数'
        },
        {
          src: require('@/assets/house/house4.png'),
          // num:this.contributorData.fileSizeCount,
          numre: 'MB',
          text: '资源总大小'
        },
        {
          src: require('@/assets/house/house5.png'),
          // num:this.contributorData.fileSizeCount,
          numre: '%',
          text: '资源已用空间'
        },
        {
          src: require('@/assets/house/house6.png'),
          // num:this.contributorData.pictureDataCount.downloadCount,
          text: '资源总下载次数'
        }
      ],
      navList: [
        {
          src: require('@/assets/house/nav1.png'),
          text: '快速上传'
        },
        {
          src: require('@/assets/house/nav3.png'),
          text: '我的下载'
        },
        {
          src: require('@/assets/house/nav2.png'),
          text: '我的资源集'
        },
        {
          src: require('@/assets/house/nav2.png'),
          text: '积分消费记录'
        }

      ],

    };
  },
  methods: {
    paramsChange(value) {
      console.log(value);
      // if (this.chartType=='月度' &&value!=='月度') {
      //   let selectMonth = value
      //   let selectMonthList = selectMonth.split('-')
      //   console.log(selectMonthList);
      // //   if (parseInt(selectMonthList[1])<10) {
      // //     selectMonthList[1] = selectMonthList[1].replace('0', '')
      // //   console.log(selectMonthList);
      // // }
      // }
      this.listDepartmentAsync()
    },
    // 初始化图表数据
    initData() {
      this.pieData[0].value = [];
      this.pieData[1].value = []
      this.departmentList.reverse()
      for (let i = 0; i < this.departmentList.length; i++) {
        
        // this.xData[i] = i;
        // this.yData =this.xData[i]*this.xData[i];
        this.pieData[0].value.push(this.departmentList[i].picCount)
        this.pieData[1].value.push(this.departmentList[i].videoCount)
        this.pieName[i] = this.departmentList[i].name;
      }
    },
    initEcharts() {
      // 饼图
      const option = {
        color: ["#3aa1ff", "#4ecb73"],
        grid: {
          left: "5%",
          right: "5%",
          bottom: "15%",
          top: "5%",
          containLabel: true,
        },
        legend: {
          top: 0,
          data: ["图片", "视频"],
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        xAxis: {
          show: true,
          type: "value",
          axisLabel: {
            show: true,
            margin: 15,
            textStyle: {
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: [
          {
            type: "category",
            axisLabel: {
              show: true,
              margin: 15,
            },
            axisLine: {
              show: true,
            },
            data: this.pieName,
          },
        ],
        series: [
          {
            name: "图片",
            type: "bar",
            zlevel: 1,
            barWidth: 20,
            data: this.pieData[0].value,
            label: {
              show: true,
              position: 'right',
              distance: 5,
              offset: [0, 2],
              fontWeight: 400,
              fontSize: 12,
              color: '#162440',
              formatter: '{a}: {@value}',
              rich: {
                unit: {
                  fontWeight: 400,
                  fontSize: 12,
                },
              },
            },
            itemStyle: {
              borderRadius: [0, 10, 10, 10],
              color: {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#5087EC',
                  },
                  {
                    offset: 1,
                    color: '#68BBC4',
                  },
                ],
                global: false,
              },
            },
          },
          {
            name: "视频",
            type: "bar",
            zlevel: 1,
            barWidth: 20,
            data: this.pieData[1].value,
            label: {
              show: true,
              position: 'right',
              distance: 5,
              offset: [0, 2],
              fontWeight: 400,
              fontSize: 12,
              color: '#162440',
              formatter: '{a}: {@value}',
              rich: {
                unit: {
                  fontWeight: 400,
                  fontSize: 12,
                },
              },
            },
            itemStyle: {
              borderRadius: [0, 10, 10, 10],
              color: {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#68BBC4',
                  },
                  {
                    offset: 1,
                    color: '#58A55C',
                  },
                ],
                global: false,
              },
            },
          },
        ],
      };

      // console.log(this.seriesData);
      // const optionFree = {
      //   xAxis: {},
      //   yAxis: {},
      //   series: [
      //     {
      //       data: this.seriesData,
      //       type: "line",
      //       smooth: true
      //     }
      //   ]
      // };
      this.myChart = echarts.init(document.getElementById("mychart1"));
      this.myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
    async listDepartmentAsync() {
      let params = {
        type: '',
        date: '',
        page: 1,
        pageSize: 100
      }
      let selectMonth = this.selectMonth
      // let selectMonthList = selectMonth.split('-')
      // if (parseInt(selectMonthList[1])<10) {
      //   selectMonthList[1] = '0' + selectMonthList[1]
      // }
      let selectYear = this.selectYear
      // selectMonth = selectMonthList[0] + '-' + selectMonthList[1]

      // console.log(selectMonth, selectYear);
      params.type = this.chartType == '月度' ? 'month' : 'year'
      params.date = this.chartType == '月度' ? selectMonth:selectYear
      let { status, data, message } = await getDepartmentCountListApi(params);
      if (status) {
        this.departmentList = data
        this.initData();
    this.initEcharts();
      } else {
        console.log(message);
      }
    },
    searchPictureapi(){
      let params={
           orderByKey:'downloadCount',
           pageSize:5,
           orderRule:0
      }
      advSearchPicture(params).then(res=>{
         if(res.status){
           res.data.forEach(item => {
              item.createTimeat=item.createTime.substring(0,10)
           });
           this.data=res.data
         }
      })
    },
    handleClick(tab, event) {
        this.activeName=tab.name
    },
    // 月度年度统计跳转
    dataSortMore() {
      this.$router.push({ path: '/digitalCenter/dataSort' })
    },
    //下载客户端
    async downloadClient(){
      let { status, data, message,errors } = await getDesktopVersion()
      if(status){
          let link = document.createElement('a') //创建a标签
          link.style.display = 'none'  //将a标签隐藏
          link.href = data.url  //给a标签添加下载链接
          link.setAttribute('target', '_blank')
          document.body.appendChild(link)  
          link.click()  //执行a标签
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //是否隐藏密码
    seePsw () {
      this.seepswFlag = !this.seepswFlag
    },
    // 复制成功时的回调函数
    onCopy (e) {
      console.log(e)
      this.$message.success("内容已复制到剪切板！")
    },
    // 复制失败时的回调函数
    onError (e) {
      this.$message.error("抱歉，复制失败！")
    },

    //图集跳转
    intoPicList (id) {
      this.$router.push({
        name: "myLibShow", //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          id: id
        }
      });
    },
    //表格行点击效果
    rowClick (row, column, event) {
      if( this.activeName=='second'){
        console.log(picPrefix);
        this.picMsg = row
        this.picMsg.createAtMY= this.picMsg.createTimeat
        this.picMsg.userName= this.picMsg.resourceCreateUserName
        console.log(this.picMsg);
        //  this.picMsg.content = data.content
        this.dialogVisible = true
      }else{
      this.picMsg = row
      this.getPictureNeedAsync(row.id)
      }
    },
    //图片邀约详情弹窗关闭事件
    handleClose () {
      this.dialogVisible = false
    },
    //我的邀约的更多
    picMore () {
      if(this.activeName=='first'){
         this.$router.push('/desktop/myPictureNeed')
      }else{
         this.$router.push('/pictureCenter')
      }
     
    },
    //最近上传的更多
    uploadMore () {
      this.$router.push('/myLib/myMediaAll')
    },
    //快速导航
    navClick (i) {
      if (i === 0) {
        this.$router.push('/pictureUpload')
      } else if (i === 1) {
        this.$router.push('/shareAndPush/myDownload')
      } else if (i === 2) {
        this.$router.push('/myLib/myMediaAll')
      } else if (i === 3) {
        // this.$message('Under development……')
        this.$router.push({
          name: 'pointRecord',
          query: {
            fir: 'userConfig',
            sec:  'userLog'
          }
        })
      }
    },
    //桌面信息
    async desktopEditorAsync (val) {
      let { status, data, message, errors } = await desktopEditor(val);
      if (status) {
        this.contributorData = data
        for (let i = 0; i < this.contributorData.pictureNeeds.length; i++) {
          this.contributorData.pictureNeeds[i].createAtMY = formatConversion(this.contributorData.pictureNeeds[i].createAt.toString()).substring(0, 10)

          if (!this.contributorData.pictureNeeds[i].userName) {
            this.contributorData.pictureNeeds[i].userName = "XXX"
          }
        }
        this.contributorData.pictureNeeds = this.contributorData.pictureNeeds.slice(0, 5)
        this.numberFlag=true
        if (this.contributorData.nasInfo) {
          this.catalog = this.contributorData.nasInfo
          this.catalog.hidpsw = '************'
          this.catalogCopy = this.catalog.path
          // this.catalogCopy = '地址：'+ this.catalog.path +'；账号：' + this.catalog.account + ';密码：' + this.catalog.password + '.'
        }
        this.numberList[0].num = parseInt(this.contributorData.createAtlasCount)
        this.numberList[1].num = parseInt(this.contributorData.createPictureCount)
        this.numberList[2].num = parseInt(this.contributorData.videoCount)
        if (this.contributorData.spaceUser!=='') {
          let size = parseFloat(this.contributorData.spaceUser)
          if (size > 1000) {
            this.numberList[3].num = parseFloat((parseInt(this.contributorData.spaceUser)  / 1024).toFixed(2))
            this.numberList[3].numre = 'GB'
          } else if (size > 100) {
            this.numberList[3].num = parseFloat((parseInt(this.contributorData.spaceUser) ).toFixed(1))
          } else {
            this.numberList[3].num = parseFloat(size)
          }

          let top = parseFloat(this.contributorData.spaceUser)
        let bottom = parseFloat(this.contributorData.spaceUser)+parseFloat(this.contributorData.spaceAvailable)
        let num = parseFloat((top*100/bottom ).toFixed(2))
        this.numberList[4].num = num
        } else {
          this.numberList[3].num = 0
          this.numberList[4].num = 0
        }
        
        
        // console.log(this.numberList[4].num ,num);
        // this.numberList[0].num = parseInt(this.contributorData.pictureDataCount.shareCount)
        this.numberList[5].num = parseInt(this.contributorData.pictureDownloadCount)+parseInt(this.contributorData.videoDownloadCount)
      } else {
        this.numberFlag=true
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //检索图集
    async searchAtlasAsync () {
      let { status, data, message, pagination, errors } = await searchAtlas({ createUid: this.createUid, pageSize: 12 });
      this.uploadsLoading = false
      if (status) {
        this.uploadsList = data
        for (let i = 0; i < this.uploadsList.length; i++) {
          this.uploadsList[i].mycreateAt = formatConversion(this.uploadsList[i].createAt.toString())
          
          if(this.uploadsList[i].posterPath == "" && this.uploadsList[i].pictureCount !== 0){
            await generateIndexPic({
              atlasId : this.uploadsList[i].id,
              isForce : true
            })
          }
          
          if (this.uploadsList[i].posterPath === "") {
            this.uploadsList[i].src = require("@/assets/house/onloadpic.png");
          } else {
            this.uploadsList[i].src = picPrefix + this.uploadsList[i].posterPath
          }

          // if (this.uploadsList[i].pictureCount == 0) {
          //   this.uploadsList[i].src = require("@/assets/house/onloadpic.png");
          // }
        }

        if (this.uploadsList.length == 0) {
          this.row = 1
        }

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //查询图片邀约
    async getPictureNeedAsync (val) {
      let { status, data, message, errors } = await getPictureNeed(val);
      if (status) {
        this.picMsg.content = data.content
        this.dialogVisible = true
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //查询用户
    async getUserAsync (val) {
      let { status, data, message } = await getUser(val);
      if (status) {
        this.picMsg.userName = data.name
        // this.detailDialogVisible = true
      } else {
        this.picMsg.userName = '用户一'
        // this.detailDialogVisible = true
      }
    },


    //判断分辨率
    judgRes () {
      // console.log(this.isAside)
      if (this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "16px"
      } else if (this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "38px"
      } else if (!this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "45px"
      } else if (!this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "75px"
      }
    }




  },

  created() {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() +1;
    this.selectMonth =currentYear+'-'+ currentMonth;
    this.selectYear = currentYear+'';
    this.listDepartmentAsync()
    let isPointsEnable = localStorage.getItem('isPointsEnable');
    if (isPointsEnable == 'false') {
      this.navList = this.navList.filter((ele) => ele.text!=='积分消费记录')
    }
    JSON.parse(localStorage.getItem('loginInfo')).powers.forEach(item=>{
      if(item == 'hotPictures'){
        this.hotspot=true
      }
    })
    //获取屏幕的宽度来控制列表的间距
    this.displayResolution = document.documentElement.clientWidth

    //分辨率
    setInterval(() => {
      this.judgRes()
    }, 888);
    this.uploadsLoading = true
    //调用图集和桌面接口
    this.searchAtlasAsync()
    this.desktopEditorAsync({ uid: this.createUid })
    // console.log(this.displayResolution);
    if (this.displayResolution > 3800) {
      this.row = 10
    } else if (this.displayResolution > 2500) {
      this.row = 7
    } else
      if (this.displayResolution >= 2350) {
        this.row = 6
      } else
        if (this.displayResolution > 2000) {
          this.row = 5
        } else
          if (this.displayResolution > 1900) {
            this.row = 5
          } else
            if (this.displayResolution > 1700) {
              this.row = 4
            }
    if (this.displayResolution <= 1700) {
      this.row = 4
    }
    if (this.displayResolution <= 1600) {
      this.row = 4
    }
    if (this.displayResolution <= 1400) {
      this.row = 3
    }




    this.creatName = JSON.parse(localStorage.getItem('loginInfo')).name
  },
  mounted () {
    
    //获取侧边栏是否收起
    this.bus.$on('changeIsaside', (message) => {
      this.bus.val = message
      this.isAside = this.bus.val
      // this.isChildren = false
    })
    this.searchPictureapi()
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./house.scss";
@import "@/constants/elHeader.scss";
.el-breadcrumb ::v-deep .el-breadcrumb__inner {
  font-size: 14px;
  color: #5c5c5c;
}
::v-deep .el-table tbody tr:hover > td {
  background-color: #fafafa;
}
::v-deep .el-table__header .has-gutter tr th div {
  color: #999999;
  font-weight: bold;
}
::v-deep .el-table tbody tr td:hover > div {
  color: #3CB035;
}
h4 {
  font-size: 18px;
}
.el-table--enable-row-hover ::v-deep .el-table__body tr:hover {
  cursor: pointer;
}
</style>
